"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { MapPin, ShieldCheck, Target, Award } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
export default function ChiSiamo() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: leftRef,
    isVisible: isLeftVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: rightRef,
    isVisible: isRightVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const timelineItems = [{
    icon: <Target className="size-5 text-primary" />,
    title: "La Nostra Missione",
    description: "Fornire consulenza ingegneristica di altissimo livello, garantendo la sicurezza sul lavoro e la conformità normativa per ogni cantiere e azienda."
  }, {
    icon: <MapPin className="size-5 text-primary" />,
    title: "Presenza sul Territorio",
    description: "Operiamo con orgoglio in tutta la Lombardia, offrendo un supporto capillare e tempestivo con un focus specifico su Monza, Milano e Brianza. Nel corso degli anni abbiamo inoltre sviluppato e seguito progetti e consulenze tecniche in diverse regioni d’Italia."
  }, {
    icon: <ShieldCheck className="size-5 text-primary" />,
    title: "Approccio Tecnico",
    description: "Con oltre 10 anni di esperienza, adottiamo un approccio tecnico rigoroso basato su analisi, normativa e progettazione integrata, garantendo soluzioni affidabili e precise nei progetti di ingegneria, sicurezza e prevenzione incendi."
  }];
  return <section id="chi-siamo" className="bg-background relative overflow-hidden py-24">
      {}
      <div className="bg-grid-black/[0.02] dark:bg-grid-white/[0.02] absolute inset-0 bg-[length:32px_32px]" />
      
      <div className="container relative mx-auto px-4 md:px-6">
        
        {}
        <div ref={headerRef} className={`mb-16 flex flex-col items-center text-center transition-all duration-700 ${isHeaderVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <div className="mb-4 inline-flex items-center gap-2 border border-border bg-muted/50 px-3 py-1 text-sm font-medium text-muted-foreground uppercase tracking-widest">
            <Award className="size-4" />
            <span>Chi Siamo</span>
          </div>
          <h2 className="text-foreground font-serif text-3xl font-bold tracking-tight md:text-4xl lg:text-5xl">
            L'Eccellenza di <span className="text-primary">Studio MESS</span>
          </h2>
          <div className="mt-6 h-1 w-24 bg-primary" />
        </div>

        <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 lg:gap-16">
          
          {}
          <div ref={leftRef} className={`relative transition-all duration-1000 ${isLeftVisible ? "translate-x-0 opacity-100" : "-translate-x-12 opacity-0"}`}>
            <div className="relative aspect-[3/4] w-full max-w-md mx-auto lg:mx-0 overflow-hidden border border-border bg-muted">
              {}
              <div className="absolute top-0 left-0 size-4 border-t-2 border-l-2 border-primary z-10" />
              <div className="absolute top-0 right-0 size-4 border-t-2 border-r-2 border-primary z-10" />
              <div className="absolute bottom-0 left-0 size-4 border-b-2 border-l-2 border-primary z-10" />
              <div className="absolute bottom-0 right-0 size-4 border-b-2 border-r-2 border-primary z-10" />
              
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1585744/img/felice_mesuraca_portrait.png" alt="Ing. Felice Mesuraca" className="h-full w-full object-cover object-center grayscale-[20%] contrast-125" />
              
              {}
              <Card className="absolute bottom-6 left-6 right-6 border-border/50 bg-background/85 backdrop-blur-md shadow-xl rounded-none">
                <CardContent className="p-5">
                  <div className="flex items-start justify-between">
                    <div>
                      <h3 className="text-foreground font-bold text-lg">Per. Ind. Felice Mesuraca</h3>
                      <p className="text-primary text-sm font-medium mt-1">Amministratore Studio Mess SRL</p>
                    </div>
                    <Award className="size-6 text-primary opacity-80" />
                  </div>
                  
                </CardContent>
              </Card>
            </div>
          </div>

          {}
          <div ref={rightRef} className={`flex flex-col justify-center transition-all duration-1000 delay-200 ${isRightVisible ? "translate-x-0 opacity-100" : "translate-x-12 opacity-0"}`}>
            <div className="mb-10">
              <p className="text-foreground/90 font-sans text-lg leading-[1.6] md:text-xl">Studio MESS S.r.l. nasce con una visione chiara: elevare gli standard di sicurezza e progettazione nel settore ingegneristico. Guidati dal Per. Ind. Felice Mesuraca, trasformiamo la complessità normativa in soluzioni operative chiare, sicure e all'avanguardia.</p>
            </div>

            {}
            <div className="relative pl-8 border-l border-border/60 space-y-10">
              {timelineItems.map((item, i) => <div key={i} data-index={i} className="relative">
                  {}
                  <div className="absolute -left-[41px] top-1 flex size-8 items-center justify-center rounded-full border-2 border-background bg-muted shadow-sm">
                    <div className="size-2 rounded-full bg-primary" />
                  </div>
                  
                  <div className="bg-card border border-border/50 p-5 shadow-sm hover:shadow-md transition-shadow duration-300">
                    <div className="mb-3 flex items-center gap-3">
                      <div className="bg-primary/10 p-2">
                        {item.icon}
                      </div>
                      <h4 className="text-foreground font-semibold text-lg">{item.title}</h4>
                    </div>
                    <p className="text-muted-foreground font-sans text-base leading-[1.6]">
                      {item.description}
                    </p>
                  </div>
                </div>)}
            </div>
            
          </div>
        </div>
      </div>
    </section>;
}